import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ListaService } from '../../_services/lista.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import {PaqueteSegurosSeguros} from '../../_models/paquete-seguros-seguros';
import {Seguro} from '../../_models/seguro';
import {SeguroPlan} from '../../_models/seguro-plan';
import {PaqueteSeguros} from '../../_models/paquete-seguros';
import {SeguroService} from '../../_services/seguro.service';
import {SeguroPlanService} from '../../_services/seguro-plan.service';
import {PaqueteSegurosSegurosService} from '../../_services/paquete-seguros-seguros.service';
import {PaqueteSegurosSegurosPlanes} from '../../_models/paquete-seguros-seguros-planes';
import {PaqueteSegurosSegurosPlanesService} from '../../_services/paquete-seguros-seguros-planes.service';
import {forkJoin} from 'rxjs';

@Component( {
  selector: 'app-paquete-seguros-seguros',
  templateUrl: 'paquete-seguros-seguros.component.html'
} )

export class PaqueteSegurosSegurosComponent implements OnInit {
  formulario: FormGroup;
  /** items */
  @Input() paquete: PaqueteSeguros;
  paqSegSeg: PaqueteSegurosSeguros;
  paqSegSegPlan: PaqueteSegurosSegurosPlanes;
  seguroLis: Seguro;
  planSeguro: SeguroPlan;


  /** Listas */
  listaSeguros: Seguro[] = [];
  listaPlanes: SeguroPlan[] = [];
  listaPlanesActivos: SeguroPlan[] = [];
  listPaqueteSeguros: PaqueteSegurosSeguros[] = [];

  lisSeguros: SelectItem[] = [];
  lisPlanes: SelectItem[] = [];

  columnas: any[] = [];
  carInformacionInicial = true;
  rowGroupMetadata: any;
  tabSeleccionado = 'VARIABLE';
  submitted = false;
  guardando = false;
  carTabla = true;
  indicadorPlan = false;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();


  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private serSeguro: SeguroService,
    private serSeguroPlan: SeguroPlanService,
    private serPaqSeguros: PaqueteSegurosSegurosService,
    private serPaqSegPlan: PaqueteSegurosSegurosPlanesService,
    private confirmacionServicio: ConfirmationService,
  ) {
  }

  ngOnInit() {
    this.cargaInicial()
  }

  cargaInicial() {
    if ( this.paquete && (this.paquete.idPaqueteSeguro !== '' && this.paquete.idPaqueteSeguro !== null && this.paquete.idPaqueteSeguro !== undefined) ) {
      /** Se carga paquete seguro seguro */

      forkJoin( this.serPaqSeguros.listadoPorPaquete( this.paquete.idPaqueteSeguro ),
        this.serPaqSegPlan.listadoPorPaquete(this.paquete.idPaqueteSeguro),
        this.serSeguroPlan.listadoEnabled()).subscribe( ( [ seguro, planesSeguros, planes  ] ) => {
          this.listaPlanesActivos = planes;
          seguro.map( ( s: PaqueteSegurosSeguros ) => {
          this.paqSegSeg = {} as PaqueteSegurosSeguros;
          this.paqSegSeg.idPaqueteSeguroSeguro = s.idPaqueteSeguroSeguro;
          this.paqSegSeg.idPaqueteSeguro = s.idPaqueteSeguro;
          this.paqSegSeg.idSeguro = s.idSeguro;
          this.paqSegSeg.nombreSeguro = s.nombreSeguro;
          this.paqSegSeg.indicadorHabilitado = s.indicadorHabilitado;
          if ( s.valorTasa > 0 ) {
            this.paqSegSeg.valorTasa = s.valorTasa;
            this.paqSegSeg.indicadorSimuladorCredito = s.indicadorSimuladorCredito;
            this.listPaqueteSeguros.push( this.paqSegSeg );
          } else {
            planesSeguros.map( ( pl: PaqueteSegurosSegurosPlanes ) => {
              if ( pl.idPaqueteSeguroSeguro === s.idPaqueteSeguroSeguro ) {
                const paqSegSegTemp = {} as PaqueteSegurosSeguros;
                paqSegSegTemp.idPaqueteSeguroSeguro = s.idPaqueteSeguroSeguro;
                paqSegSegTemp.idPaqueteSeguro = s.idPaqueteSeguro;
                paqSegSegTemp.idSeguro = s.idSeguro;
                paqSegSegTemp.nombreSeguro = s.nombreSeguro;
                paqSegSegTemp.indicadorHabilitado = s.indicadorHabilitado;
                paqSegSegTemp.idPaqueteSeguroSeguroPlan = pl.idPaqueteSeguroSeguroPlan;
                paqSegSegTemp.idSeguroPlan = pl.idSeguroPlan;
                paqSegSegTemp.planSeguro = pl.nombrePlan;
                paqSegSegTemp.valorPlan = pl.valorPlan;
                paqSegSegTemp.indicadorHabilitadoPlan = pl.indicadorHabilitado;
                paqSegSegTemp.indicadorSimuladorCredito = pl.indicadorSimuladorCredito;
                this.listPaqueteSeguros.push( paqSegSegTemp );
              }
            } );
          }
        } );
        this.paqSegSeg = {} as PaqueteSegurosSeguros;
        this.cargarInformacionInicial();
      } );
    }
  }

  get paqSegurosSeguros() {
    return this.listPaqueteSeguros.filter( s => s.indicadorHabilitado && ((!s.idPaqueteSeguroSeguroPlan) || (s.idPaqueteSeguroSeguroPlan && s.indicadorHabilitadoPlan)));
  }


  cargarInformacionInicial() {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/paquete-seguros' );
    if ( mn ) {
      this.menu = mn;
    }
    this.carTabla = false;
    this.carInformacionInicial = false;
    this.paqSegSeg = {} as PaqueteSegurosSeguros;
    this.paqSegSegPlan = {} as PaqueteSegurosSegurosPlanes;

    this.columnas = [
      { field: 'nombreSeguro', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_PRODUCTO_SEGURO' ), sort: true },
      { field: 'simuladorCredito', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_SIMULADORCREDITO' ), sort: false },
      { field: 'planSeguro', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_PLAN' ), sort: true },
      { field: 'valorPlan', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_VALOR_PLAN' ), sort: true },
      { field: 'valorTasa', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_TASA' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.formulario = this.fb.group( {
      idSeguro: [ this.paqSegSeg ? this.paqSegSeg.idSeguro : null, [ Validators.required ] ],
      idSeguroPlan: [ this.paqSegSeg ? this.paqSegSeg.idSeguroPlan : null ],
      idPaqueteSeguro: [ this.paquete ? this.paquete.idPaqueteSeguro : null, [ Validators.required ] ],
      indicadorSimuladorCredito: [ this.paqSegSeg && this.paqSegSeg.indicadorSimuladorCredito ? this.paqSegSeg.indicadorSimuladorCredito : false, [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );

    this.f.idSeguroPlan.setValue(null);
    this.f.idSeguroPlan.setValidators( null);
    this.f.idSeguroPlan.updateValueAndValidity();

    this.indicadorPlan = false;

    this.serSeguro.listadoEnabled().subscribe( registros => {
      this.listaSeguros = registros;
      const  listaSeguros = this.listPaqueteSeguros.filter( s => s.indicadorHabilitado);
      this.lisSeguros = [];
      this.listaSeguros.map( ( s: Seguro ) => {

        let paqSegSegTemp = {} as PaqueteSegurosSeguros;
        paqSegSegTemp = listaSeguros.find( x => x.idSeguro === s.idSeguro);
        if ( paqSegSegTemp && paqSegSegTemp.idPaqueteSeguroSeguro ) {
          if ( !paqSegSegTemp.valorTasa ) {
            const pagSegPlan = this.listPaqueteSeguros.filter( p => p.idPaqueteSeguroSeguro === paqSegSegTemp.idPaqueteSeguroSeguro && p.indicadorHabilitadoPlan).length;
            const planes = this.listaPlanesActivos.filter(pl => pl.idSeguro === s.idSeguro && pl.indicadorHabilitado).length;
            if ( planes > pagSegPlan ) {
              this.lisSeguros.push( { label: s.nombre, value: s.idSeguro } );
            }
          }
        } else {
          this.lisSeguros.push( { label: s.nombre, value: s.idSeguro } );
        }
      } );
      this.carTabla = false;
      this.carInformacionInicial = false;

    } );
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.carTabla = true;
      this.carInformacionInicial = true;

      const temp: PaqueteSegurosSeguros = this.formulario.value;

      this.paqSegSeg = {} as PaqueteSegurosSeguros;
      this.paqSegSegPlan = {} as PaqueteSegurosSegurosPlanes;
      this.paqSegSeg.idPaqueteSeguro = this.paquete.idPaqueteSeguro;
      this.paqSegSeg.indicadorHabilitado = true;
      this.paqSegSeg.idSeguro = temp.idSeguro;
      this.paqSegSeg.indicadorSimuladorCredito = temp.indicadorSimuladorCredito;
      if ( this.listPaqueteSeguros.find( x => x.idSeguro === temp.idSeguro ) ) {

        this.paqSegSeg.idPaqueteSeguroSeguro = this.listPaqueteSeguros.find( x => x.idSeguro === temp.idSeguro).idPaqueteSeguroSeguro;
          this.serPaqSeguros.actualizar( this.paqSegSeg ).subscribe( res => {
            this.paqSegSeg = res;
            if ( temp.idSeguroPlan !== '' && temp.idSeguroPlan !== undefined && temp.idSeguroPlan !== null ) {
              let paqSegSegPlanTemp = {} as PaqueteSegurosSeguros;
              paqSegSegPlanTemp = this.listPaqueteSeguros.find( x => x.idSeguroPlan === temp.idSeguroPlan);
              this.paqSegSegPlan.idPaqueteSeguroSeguro = res.idPaqueteSeguroSeguro;
              this.paqSegSegPlan.idSeguroPlan = temp.idSeguroPlan;
              this.paqSegSegPlan.indicadorHabilitado = true;
              this.paqSegSegPlan.indicadorSimuladorCredito = temp.indicadorSimuladorCredito;
              if ( paqSegSegPlanTemp && paqSegSegPlanTemp.idPaqueteSeguroSeguroPlan ) {
                this.paqSegSegPlan.idPaqueteSeguroSeguroPlan = paqSegSegPlanTemp.idPaqueteSeguroSeguroPlan;
                this.serPaqSegPlan.actualizar( this.paqSegSegPlan ).subscribe( pl => {
                  const paqueteTemp: PaqueteSegurosSeguros[] = this.listPaqueteSeguros;
                  this.listPaqueteSeguros = [];
                  paqueteTemp.map( t => {
                    if ( t.idSeguroPlan === pl.idSeguroPlan ) {
                      t.indicadorHabilitado = true;
                      t.indicadorHabilitadoPlan = true;
                    }
                  } );
                  this.listPaqueteSeguros = paqueteTemp;
                  this.formulario.reset();
                  this.formulario.controls.idPaqueteSeguro.setValue(this.paquete.idPaqueteSeguro);
                  this.formulario.controls.indicadorSimuladorCredito.setValue(false);
                  this.submitted = false;
                  this.navServicio.setMesage( 1 );
                  this.paqSegSeg.idPaqueteSeguroSeguroPlan = pl.idPaqueteSeguroSeguroPlan;
                  this.paqSegSeg.idSeguroPlan = pl.idSeguroPlan;
                  this.addLista(this.paqSegSeg);
                  this.cargarInformacionInicial();
                } );
              } else {
                this.serPaqSegPlan.crear(this.paqSegSegPlan).subscribe( plan => {
                  this.paqSegSeg.idPaqueteSeguroSeguroPlan = plan.idPaqueteSeguroSeguroPlan;
                  this.paqSegSeg.idSeguroPlan = temp.idSeguroPlan;
                  this.paqSegSeg.indicadorSimuladorCredito = temp.indicadorSimuladorCredito;
                  this.addLista(this.paqSegSeg);
                } );
              }
            } else {
              const paqueteTemp: PaqueteSegurosSeguros[] = this.listPaqueteSeguros;
              this.listPaqueteSeguros = [];
              paqueteTemp.map( t => {
                if ( t.idPaqueteSeguroSeguro === res.idPaqueteSeguroSeguro ) {
                  t.indicadorHabilitado = true;
                  t.indicadorSimuladorCredito = temp.indicadorSimuladorCredito;
                }
              } );
              this.listPaqueteSeguros = paqueteTemp;
              this.formulario.reset();
              this.formulario.controls.idPaqueteSeguro.setValue(this.paquete.idPaqueteSeguro);
              this.formulario.controls.indicadorSimuladorCredito.setValue(false);
              this.submitted = false;
              this.navServicio.setMesage( 1 );
              this.cargarInformacionInicial();
            }
          } );
        this.paqSegSeg = {} as PaqueteSegurosSeguros;
        this.paqSegSegPlan = {} as PaqueteSegurosSegurosPlanes;
      } else {
          this.serPaqSeguros.crear( this.paqSegSeg ).subscribe( res => {
            this.paqSegSeg.idPaqueteSeguroSeguro = res.idPaqueteSeguroSeguro;
            this.paqSegSeg.indicadorSimuladorCredito = res.indicadorSimuladorCredito;
            if ( temp.idSeguroPlan !== '' && temp.idSeguroPlan !== null && temp.idSeguroPlan !== undefined ) {
              this.paqSegSegPlan.idPaqueteSeguroSeguro = res.idPaqueteSeguroSeguro;
              this.paqSegSegPlan.idSeguroPlan = temp.idSeguroPlan;
              this.paqSegSegPlan.indicadorHabilitado = true;
              this.paqSegSegPlan.indicadorSimuladorCredito = temp.indicadorSimuladorCredito;
              this.serPaqSegPlan.crear(this.paqSegSegPlan).subscribe( plan => {
                this.paqSegSeg.idPaqueteSeguroSeguroPlan = plan.idPaqueteSeguroSeguroPlan;
                this.paqSegSeg.idSeguroPlan = temp.idSeguroPlan;
                this.addLista(this.paqSegSeg);
              } );
            } else {
              this.addLista(this.paqSegSeg);
            }
          } );
      }

      // this.cargaInicial()
    }
  }

  cambioPLan() {
    this.seguroLis = this.listaSeguros.find(x => x.idSeguro === this.f.idSeguro.value);
    if ( !this.seguroLis.indicadorTasa ) {
      this.serSeguroPlan.listadoPorIdSeguro(this.f.idSeguro.value).subscribe( registros => {
        this.listaPlanes = registros;
        this.lisPlanes = [];
        this.listaPlanes.map( ( s: SeguroPlan ) => {
          let paqSegSegTemp = {} as PaqueteSegurosSeguros;
          if (s.indicadorHabilitado) {
              paqSegSegTemp = this.listPaqueteSeguros.find(x => x.idSeguroPlan === s.idSeguroPlan);
            if (paqSegSegTemp) {
              if (!paqSegSegTemp.indicadorHabilitadoPlan) {
                this.lisPlanes.push({label: s.nombre, value: s.idSeguroPlan});
              }
            } else {
              this.lisPlanes.push({label: s.nombre, value: s.idSeguroPlan});
            }
          }

        } );
        this.lisPlanes.sort( (a, b) => {
          if ( a.label < b.label ) {
            return -1;
          }
          return 1;
        });
        this.indicadorPlan = true;
        this.f.idSeguroPlan.setValue(null);
        this.f.idSeguroPlan.setValidators( [Validators.required] );
        this.f.idSeguroPlan.updateValueAndValidity();
        this.submitted = false;

      } );
    } else {
      this.f.idSeguroPlan.setValue(null);
      this.f.idSeguroPlan.setValidators( null);
      this.f.idSeguroPlan.updateValueAndValidity();

      this.indicadorPlan = false;
    }
  }

  disable( row: PaqueteSegurosSeguros ): void {
    this.confirmacionServicio.confirm( {
      message: '¿Está seguro que desea inactivar este registro?',
      header: 'Paquetes Seguros Seguros',
      icon: 'fa fa-question-circle',
      key: 'paquetesSegurosSeguros',
      accept: () => {
        this.carInformacionInicial = true;
        row.indicadorHabilitado = false;
        this.paqSegSeg = {} as PaqueteSegurosSeguros;
        this.paqSegSegPlan = {} as PaqueteSegurosSegurosPlanes;
        this.paqSegSeg.idPaqueteSeguro = row.idPaqueteSeguro;
        this.paqSegSeg.indicadorHabilitado = false;
        this.paqSegSeg.idSeguro = row.idSeguro;
        this.paqSegSeg.idPaqueteSeguroSeguro = row.idPaqueteSeguroSeguro;
        if ( row.idSeguroPlan !== null && row.idSeguroPlan !== '' && row.idSeguroPlan !== undefined ) {
          this.paqSegSegPlan.idPaqueteSeguroSeguro = row.idPaqueteSeguroSeguro;
          this.paqSegSegPlan.idSeguroPlan = row.idSeguroPlan;
          this.paqSegSegPlan.indicadorHabilitado = false;
          this.paqSegSegPlan.idPaqueteSeguroSeguroPlan = row.idPaqueteSeguroSeguroPlan;
          this.serPaqSegPlan.actualizar( this.paqSegSegPlan ).subscribe( () => {
            const pagSegPlan = this.listPaqueteSeguros.filter(
              p => p.idPaqueteSeguroSeguro === row.idPaqueteSeguroSeguro && p.indicadorHabilitadoPlan).length;
            if ( pagSegPlan > 1 ) {
              const paqueteTemp: PaqueteSegurosSeguros[] = this.listPaqueteSeguros;
              this.listPaqueteSeguros = [];
              paqueteTemp.map( t => {
                if ( t.idSeguroPlan === row.idSeguroPlan ) {
                  t.indicadorHabilitado = false;
                  t.indicadorHabilitadoPlan = false;
                }
              } );
              this.listPaqueteSeguros = paqueteTemp;
              this.cargarInformacionInicial();
            } else {
              this.paqSegSeg.idPaqueteSeguro = row.idPaqueteSeguro;
              this.paqSegSeg.indicadorHabilitado = false;
              this.paqSegSeg.idSeguro = row.idSeguro;
              this.paqSegSeg.idPaqueteSeguroSeguro = row.idPaqueteSeguroSeguro;

              this.serPaqSeguros.actualizar( this.paqSegSeg ).subscribe( () => {
                const paqueteTemp: PaqueteSegurosSeguros[] = this.listPaqueteSeguros;
                this.listPaqueteSeguros = [];
                paqueteTemp.map( t => {
                  if ( t.idPaqueteSeguroSeguro === row.idPaqueteSeguroSeguro ) {
                    t.indicadorHabilitado = false;
                    t.indicadorHabilitadoPlan = false;
                  }
                } );
                this.listPaqueteSeguros = paqueteTemp;
                this.cargarInformacionInicial();
              } );
            }
          } );
        } else {
          this.serPaqSeguros.actualizar( this.paqSegSeg ).subscribe( () => {
            const temp: PaqueteSegurosSeguros[] = this.listPaqueteSeguros;
            this.listPaqueteSeguros = [];
            temp.map( t => {
              if ( t.idPaqueteSeguroSeguro === row.idPaqueteSeguroSeguro ) {
                t.indicadorHabilitado = false;
              }
            } );
            this.listPaqueteSeguros = temp;
            this.cargarInformacionInicial();
          } );
        }
        this.paqSegSeg = {} as PaqueteSegurosSeguros;
        this.paqSegSegPlan = {} as PaqueteSegurosSegurosPlanes;
      }
    } );
  }

  addLista( row: PaqueteSegurosSeguros ): void {

    if ( row.idSeguroPlan !== '' && row.idSeguroPlan !== null && row.idSeguroPlan !== undefined ) {
      this.paqSegSeg.nombreSeguro = this.listaSeguros.find( s => s.idSeguro === row.idSeguro).nombre;
      this.paqSegSeg.planSeguro = this.listaPlanes.find( p => p.idSeguroPlan === row.idSeguroPlan).nombre;
      this.paqSegSeg.valorPlan = this.listaPlanes.find( p => p.idSeguroPlan === row.idSeguroPlan).valor;
      this.paqSegSeg.indicadorHabilitadoPlan = true;
      const index = this.listPaqueteSeguros.findIndex((x) => x.idPaqueteSeguroSeguroPlan === row.idPaqueteSeguroSeguroPlan);
      if (index !== -1) {
        this.listPaqueteSeguros[index] = this.paqSegSeg;
      } else {
        this.listPaqueteSeguros.push( this.paqSegSeg );
      }

      this.cargarInformacionInicial();
      this.formulario.reset();
      this.formulario.controls.idPaqueteSeguro.setValue(this.paquete.idPaqueteSeguro);
      this.formulario.controls.indicadorSimuladorCredito.setValue(false);
      this.submitted = false;
      this.navServicio.setMesage( 1 );
    } else {
      this.paqSegSeg.nombreSeguro = this.listaSeguros.find( s => s.idSeguro === row.idSeguro).nombre;
      this.paqSegSeg.valorTasa = this.listaSeguros.find( s => s.idSeguro === row.idSeguro).valorTasa;
      const index = this.listPaqueteSeguros.findIndex((x) => x.idPaqueteSeguroSeguro === row.idPaqueteSeguroSeguro);
      if (index !== -1) {
        this.listPaqueteSeguros[index] = this.paqSegSeg;
      } else {
        this.listPaqueteSeguros.push( this.paqSegSeg );
      }
      this.formulario.reset();
      this.formulario.controls.idPaqueteSeguro.setValue(this.paquete.idPaqueteSeguro);
      this.formulario.controls.indicadorSimuladorCredito.setValue(false);
      this.submitted = false;
      this.navServicio.setMesage( 1 );
      this.cargarInformacionInicial();
    }
  }
}
